import * as Consts from "../ts/rlAdmin.consts";
import { LayoutController } from "../ts/rlAdmin.controllers";


export function RLSidepanelToggle() {
    var directive: ng.IDirective = {
        restrict: 'A',
        controller: RLSidepanelToggleController,
        controllerAs: "sptVM",
        template: require("/assets/app/templates/sidepanel-toggle.html"),
        scope: {
            layoutModel: '=',
            entityToWatch: '=?'
        },
        bindToController: true
    };
    return directive;
}

export class RLSidepanelToggleController {
    static $inject = ["$scope"];

    layoutModel: LayoutController;
    entityToWatch: any;

    get IsSidePanelOpen(): boolean {
        return this.layoutModel.layoutState.isSidePanelOpen;
    }
    get IsSidePanelClosed(): boolean {
        return !this.layoutModel.layoutState.isSidePanelOpen;
    }

    constructor(
        private $scope: ng.IScope) {

        $scope.$watch(() => this.entityToWatch, (newValue) => {
            if (newValue) {
                if (this.IsSidePanelClosed) {
                    this.ToggleSidePanel();
                }
            }
        });

        $scope.$on(Consts.Events.ViewEntity, (event, args) => {
            if (this.IsSidePanelClosed) {
                this.ToggleSidePanel();
            }
        });

        $scope.$on(Consts.Events.ViewEntityRelationshipPair, (event, args) => {
            if (this.IsSidePanelClosed) {
                this.ToggleSidePanel();
            }
        });

    }

    ToggleSidePanel() {
        this.layoutModel.ToggleSidePanel();
    }
}